import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import PDFLogo from '@/components/pdf/PDFLogo';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#ffffff',
    padding: 40,
    paddingTop: 70,
    paddingBottom: 50,
    fontFamily: 'Helvetica',
  },
  headerBar: {
    position: 'absolute',
    top: 20,
    left: 40,
    right: 40,
    height: 30,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  logo: {
    width: 90,
    height: 22,
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 40,
    right: 40,
    textAlign: 'center',
    fontSize: 9,
    color: '#6b7280',
  },
  container: {
    flex: 1,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: '#000000',
    lineHeight: 1.2,
  },
  section: {
    marginBottom: 20,
  },
  heading: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#000000',
  },
  text: {
    fontSize: 12,
    marginBottom: 10,
    color: '#000000',
    lineHeight: 1.5,
  },
  important: {
    backgroundColor: '#f0f9ff',
    padding: 10,
    marginVertical: 10,
    borderRadius: 4,
  },
  importantText: {
    fontSize: 12,
    color: '#000000',
    fontWeight: 'bold',
  },
  list: {
    marginLeft: 20,
  },
  listItem: {
    fontSize: 12,
    marginBottom: 5,
    color: '#000000',
  },
});

export const AssessmentInstructionsPDF = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.headerBar}>
        <PDFLogo width={90} height={22} />
      </View>
      <View style={styles.container}>
        <Text style={styles.title}>
          Organizational Capacity Building{`\n`}Assessment Instructions
        </Text>

        <View style={styles.section}>
          <Text style={styles.text}>
            Your organization is unique, with its own mission, vision, and values that inspire meaningful change. 
            That purpose is the heart of your work, it guides your decisions, fuels your motivation, and shapes 
            the difference you make.
          </Text>
          
          <Text style={styles.text}>
            This assessment is designed to help you take a clear, constructive look at your strengths and 
            opportunities, providing insights and action steps you can adapt to your organization's specific 
            context and goals.
          </Text>

          <View style={styles.important}>
            <Text style={styles.importantText}>
              Important Note: This is not a test, nor is it a performance evaluation. There are no right or wrong answers.
            </Text>
          </View>

          <Text style={styles.text}>
            Instead, think of it as a guided reflection, a moment to pause and consider where your organization 
            is today and where you want it to be tomorrow.
          </Text>

          <Text style={styles.text}>
            The insights you share will help create a tailored plan to strengthen your operations, programs/services, 
            and long-term sustainability. This is your pathway to purpose. Be yourself, stay curious, and enjoy the journey.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.heading}>What You'll Be Doing</Text>
          <Text style={styles.text}>
            You'll answer a series of questions across key domains of a nonprofit organization. The assessment 
            usually takes about 30-45 minutes to complete and can be done on your own or with input from your 
            leadership team, staff, or board, whatever works best for your organization's size and structure.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.heading}>How to Approach the Assessment</Text>
          <View style={styles.important}>
            <Text style={styles.importantText}>
              Important Note: Research consistently shows that people often assess their competencies as 
              higher than they actually are.
            </Text>
          </View>
          <View style={styles.list}>
            <Text style={styles.listItem}>• Be reflective and candid. This is about your current reality, not your future goals.</Text>
            <Text style={styles.listItem}>• Avoid being overly critical or overly optimistic; aim for accuracy of your current state.</Text>
            <Text style={styles.listItem}>• If you're not 100% sure of a choice, please choose the previously listed option.</Text>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.heading}>What Happens Next</Text>
          <Text style={styles.text}>
            Your responses will inform a practical, mission-aligned pathway to strengthen your organization's 
            development, effectiveness, and long-term impact.
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.heading}>Final Thought</Text>
          <Text style={styles.text}>
            By engaging in this process, you're making an investment in your organization's future. Thank you 
            for your thoughtful participation and your commitment to building a stronger, more resilient 
            organization for the community you serve.
          </Text>
        </View>
      </View>
      <Text style={styles.footer}>Copyright @ 2025 ViaTelos. All Rights Reserved.</Text>
    </Page>
  </Document>
);
